import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  TOKEN = 'Bearer ' + window.localStorage.getItem('token');

  constructor(private httpClient: HttpClient) { }

  get() {
    const companyId = window.localStorage.getItem('company_id');
    const logged_user = window.localStorage.getItem('user_id');
    const fy = window.localStorage.getItem('fy');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/dashboard/standard/read/?company_id=` + companyId + '&logged_user=' + logged_user + '&fy=' + fy, { headers: headers });
  }

  getCalendarDetails() {
    const companyId = window.localStorage.getItem('company_id');
    const logged_user = window.localStorage.getItem('user_id');
    const fy = window.localStorage.getItem('fy');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/dashboard/standard/getcalendardetails/?company_id=` + companyId + '&logged_user=' + logged_user + '&fy=' + fy, { headers: headers });
  }

  getCustomerSummary() {
    const companyId = window.localStorage.getItem('company_id');
    const logged_user = window.localStorage.getItem('user_id');
    const fy = window.localStorage.getItem('fy');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/dashboard/standard/getCustomerSummery/?company_id=` + companyId + '&logged_user=' + logged_user + '&fy=' + fy, { headers: headers });
  }

  getByDate(date) {
    const companyId = window.localStorage.getItem('company_id');
    const logged_user = window.localStorage.getItem('user_id');
    const fy = window.localStorage.getItem('fy');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/reports/bydate/?company_id=` + companyId + '&logged_user=' + logged_user + '&date=' + date + '&fy=' + fy, { headers: headers });
  }

  getByAmount() {
    const companyId = window.localStorage.getItem('company_id');
    const logged_user = window.localStorage.getItem('user_id');
    const fy = window.localStorage.getItem('fy');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/dashboard/byamount/read/?company_id=` + companyId + '&logged_user=' + logged_user + '&fy=' + fy, { headers: headers });
  }

  //new API for demo
  getByInvoices() {
    const companyId = window.localStorage.getItem('company_id');
    const logged_user = window.localStorage.getItem('user_id');
    const fy = window.localStorage.getItem('fy');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/dashboard/byinvoice/read/?company_id=` + companyId + '&logged_user=' + logged_user + '&fy=' + fy, { headers: headers });
  }

  getByInvoicesAmount() {
    const companyId = window.localStorage.getItem('company_id');
    const logged_user = window.localStorage.getItem('user_id');
    const fy = window.localStorage.getItem('fy');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/dashboard/standard/readInvoiceAmount/?company_id=` + companyId + '&logged_user=' + logged_user + '&fy=' + fy, { headers: headers });
  }

  isUserAutherised() {
    const userId = window.localStorage.getItem('user_id');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/isauthorised?user_id=${userId}`, { headers: headers });
  }

  get_tally_dashboard() {
    const companyId = window.localStorage.getItem('company_id');
    const fy = window.localStorage.getItem('fy');
    const userId = window.localStorage.getItem('user_id');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/tallytcpV2/dashboard/get_tally_dashboard/?company_id=` + companyId + '&user_id=' + userId + '&fy=' + fy, { headers: headers });
  }

    get_tally_dashboard_by_salesOrg(data) {
    const companyId = window.localStorage.getItem('company_id');
    const fy = window.localStorage.getItem('fy');
    const userId = window.localStorage.getItem('user_id');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.post(`${environment.api_rul}/tallytcpV2/dashboard/get_tally_dashboardbysalesorg/?company_id=` + companyId + '&user_id=' + userId + '&fy=' + fy,data, { headers: headers });
  }

  //bydate_tally_bill
  get_tally_bill_by_date(date) {
    const companyId = window.localStorage.getItem('company_id');
    const logged_user = window.localStorage.getItem('user_id');
    const fy = window.localStorage.getItem('fy');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/tallytcpV2/dashboard/bydate_tally_bill_by_date/?company_id=` + companyId + '&logged_user=' + logged_user + '&date=' + date + '&fy=' + fy, { headers: headers });
  }

  get_tally_calendar_details() {
    const companyId = window.localStorage.getItem('company_id');
    const logged_user = window.localStorage.getItem('user_id');
    const fy = window.localStorage.getItem('fy');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/tallytcpV2/dashboard/get_tally_calendar_details/?company_id=` + companyId + '&logged_user=' + logged_user + '&fy=' + fy, { headers: headers });
  }

  get_tally_ByAmount() {
    const companyId = window.localStorage.getItem('company_id');
    const logged_user = window.localStorage.getItem('user_id');
    const fy = window.localStorage.getItem('fy');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/tallytcpV2/dashboard/get_tally_by_amount_dashboard/?company_id=` + companyId + '&logged_user=' + logged_user + '&fy=' + fy, { headers: headers });
  }

  get_all_company_consolidated_dashboard(companies) {
    const companyId = window.localStorage.getItem('company_id');
    const logged_user = window.localStorage.getItem('user_id');
    const fy = window.localStorage.getItem('fy');
    const userId = window.localStorage.getItem('user_id');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/tallytcpV2/dashboard/get_all_company_consolidated/?fy=${fy}&companies=${companies}&user_id=${userId}&company_id=${companyId}`);
  }

  getVchtypeSummry(Fromdts, Todts) {
    const companyId = window.localStorage.getItem('company_id');
    const logged_user = window.localStorage.getItem('user_id');
    const fy = window.localStorage.getItem('fy');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    let TPO_v_fromdate = Fromdts;
    let TPO_v_todate = Todts;//'2022-03-31';
    return this.httpClient.get(`${environment.api_rul}/tallytcpV2/dashboard/get_current_month_dashboard?company_id=` + companyId + '&fromdate=' + TPO_v_fromdate + '&todate=' + TPO_v_todate, { headers: headers });
  }

  getOverCreditLimit() {
    const companyId = window.localStorage.getItem('company_id');
    const fy = window.localStorage.getItem('fy');
    const userid = window.localStorage.getItem('user_id');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/tallytcpV2/getOvercreditlimit/?company_id=` + companyId + `&user_id=` + userid, { headers: headers });
  }

  getHighestOutstanding() {
    const companyId = window.localStorage.getItem('company_id');
    const fy = window.localStorage.getItem('fy');
    const userid = window.localStorage.getItem('user_id');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/tallytcpV2/getHighestOutstanding/?company_id=` + companyId + `&user_id=` + userid, { headers: headers });
  }

  getAllLedger() {
    const companyId = window.localStorage.getItem('company_id');
    const fy = window.localStorage.getItem('fy');
    const userid = window.localStorage.getItem('user_id');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/dashboard/byledger/get_all_ledger/?company_id=` + companyId + `&user_id=` + userid, { headers: headers });
  }

  get_Ledger_by_id(ledger_id) {
    const companyId = window.localStorage.getItem('company_id');
    const fy = window.localStorage.getItem('fy');
    const userid = window.localStorage.getItem('user_id');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/dashboard/byledger/get_by_ledger/?company_id=${companyId}&user_id=${userid}&ledger_id=${ledger_id}&fy=${fy}`, { headers: headers });
  }

  get_SalesOfficeList() {
    const companyId = window.localStorage.getItem('company_id');
    const fy = window.localStorage.getItem('fy');
    const userid = window.localStorage.getItem('user_id');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/invoiceFollowup/get_salesOfficeList/?company_id=${companyId}&fy=${fy}&userid=${userid}`, { headers: headers });
  }

    get_CustomerDaybook(data) {
    const companyId = window.localStorage.getItem('company_id');
    const fy = window.localStorage.getItem('fy');
    const userid = window.localStorage.getItem('user_id');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.post(`${environment.api_rul}/invoiceFollowup/get_invoice_Daybook/?company_id=${companyId}&fy=${fy}`,data, { headers: headers });
  }

    get_SalesOfficeListwithmrdata() {
    const companyId = window.localStorage.getItem('company_id');
    const fy = window.localStorage.getItem('fy');
    const userid = window.localStorage.getItem('user_id');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/invoiceFollowup/get_salesOfficeListwithmrdate/?company_id=${companyId}&fy=${fy}&userid=${userid}`, { headers: headers });
  }

    get_SalesOfficeListAlldata() {
    const companyId = window.localStorage.getItem('company_id');
    const fy = window.localStorage.getItem('fy');
    const userid = window.localStorage.getItem('user_id');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/invoiceFollowup/get_salesOfficeListAlldata/?company_id=${companyId}&fy=${fy}&userid=${userid}`, { headers: headers });
  }

}
